import { useState, useEffect } from 'react';
import axios from 'axios';
import { axiosApi } from '../../api/setupApi';

const useIAList = () => {
  const [iaList, setIaList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchIAList = async () => {
    setLoading(true);
    setError(null);
    try {
  const { data } = await axiosApi.get('/cisbohol/ia-list');
  setIaList(data);
    } catch (err) {
      console.error('Error fetching IA list:', err);
      setError('Failed to fetch IA list');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchIAList();
  }, []);

  const refetch = () => {
    fetchIAList();
  };

  return { iaList, loading, error, refetch };
};

export default useIAList;